import { AccessTokenCache } from 'infra/cache/set-access-token-cache'
import { makeCacheLocalStorage } from './cache-local-storage-factory'

export const makeAccessTokenCache = () => new AccessTokenCache(makeCacheLocalStorage())
